module.exports = __webpack_public_path__ + "static/img/11.4760bc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/11.png
// module id = 54dm
// module chunks = 0